import { useState } from 'react';
interface LogoWithFallbackProps {
  className?: string;
  alt?: string;
  size?: number;
}

const CACHE_KEY = 'site_logo_url';
const CACHE_VERSION_KEY = 'site_logo_version';
const CACHE_VERSION = 'v5_bulb_logo_2026'; // 版本号，更换logo时更新此值

// 灯泡Logo SVG — 作为图片加载失败时的 fallback，绝不回退到 meoo logo
const BulbLogoSVG = ({ size = 40 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* 灯泡外轮廓 */}
    <path
      d="M100 20C60 20 30 50 30 90C30 115 45 135 65 150L65 170C65 180 75 185 80 185L120 185C125 185 135 180 135 170L135 150C155 135 170 115 170 90C170 50 140 20 100 20Z"
      fill="#FBBF24"
      stroke="#F59E0B"
      strokeWidth="4"
    />
    {/* 灯泡内部光芒 */}
    <path
      d="M100 40C70 40 50 60 50 90C50 110 60 125 75 135L75 165L125 165L125 135C140 125 150 110 150 90C150 60 130 40 100 40Z"
      fill="#FDE68A"
    />
    {/* 灯泡底座 */}
    <rect x="75" y="165" width="50" height="8" rx="2" fill="#9CA3AF" />
    <rect x="80" y="175" width="40" height="6" rx="2" fill="#6B7280" />
    <rect x="85" y="183" width="30" height="5" rx="2" fill="#4B5563" />
    {/* 灯丝 */}
    <path
      d="M90 80 Q95 70 100 80 Q105 70 110 80"
      stroke="#D97706"
      strokeWidth="3"
      fill="none"
    />
    {/* 光芒射线 */}
    <line x1="100" y1="5" x2="100" y2="15" stroke="#FBBF24" strokeWidth="3" strokeLinecap="round" />
    <line x1="140" y1="15" x2="135" y2="25" stroke="#FBBF24" strokeWidth="3" strokeLinecap="round" />
    <line x1="60" y1="15" x2="65" y2="25" stroke="#FBBF24" strokeWidth="3" strokeLinecap="round" />
    <line x1="170" y1="50" x2="160" y2="55" stroke="#FBBF24" strokeWidth="3" strokeLinecap="round" />
    <line x1="30" y1="50" x2="40" y2="55" stroke="#FBBF24" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export default function LogoWithFallback({
  className = 'h-10 w-10 object-contain',
  alt = '编程优题库',
  size = 40,
}: LogoWithFallbackProps) {
  // 检查缓存版本，如果版本号不匹配则清除旧缓存
  const cachedVersion = localStorage.getItem(CACHE_VERSION_KEY);
  if (cachedVersion !== CACHE_VERSION) {
    localStorage.removeItem(CACHE_KEY);
    localStorage.setItem(CACHE_VERSION_KEY, CACHE_VERSION);
  }

  // 使用灯泡logo（PNG格式）
  const [imgSrc] = useState<string>('https://conversation.cdn.meoo.host/conversations/304527882754134016/image/2026-06-05/1780669620456-logo.png?auth_key=898cc3493d68443e1ec1ffbb47a75b220e029133fccc3e8121d06ecaec17f372');
  const [imgError, setImgError] = useState(false);

  if (imgError) {
    // 图片加载失败时，显示灯泡Logo SVG，绝不回退到 meoo logo
    return (
      <div className={`flex items-center gap-2.5 ${className}`}>
        <BulbLogoSVG size={size} />
        <div className="flex items-baseline gap-0 select-none leading-none whitespace-nowrap" style={{ fontFamily: "'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Noto Sans SC', sans-serif" }}>
          <span className="text-base font-bold text-gray-900">编程优题库</span>
          <span className="text-sm font-bold ml-1.5 bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">UDO100.com</span>
        </div>
      </div>
    );
  }

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      onError={() => setImgError(true)}
    />
  );
}